module.exports = __webpack_public_path__ + "static/media/stp_card_jcb.4dca6613.png";